module.exports = __webpack_public_path__ + "media/sophia_hold_tight_demo.14b443e7.mp3";